import React from 'react';
import { FaFacebook, FaInstagram, FaBuilding,FaYoutube, FaWhatsapp, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const ContactUs = () => {
  const branchLocations = [
    {
      name: "Main Campus",
      address: "123 Education Street, Knowledge City",
      phone: "+1 (555) 123-4567",
      email: "main@dnet.edu"
    },
    // {
    //   name: "Westside Branch",
    //   address: "456 Learning Avenue, West District",
    //   phone: "+1 (555) 765-4321",
    //   email: "west@dnet.edu"
    // }
  ];

  return (
    <>
      {/* Hero Section */}
      <section className="Subpage_Hero">
        <div className="container">
          <div className="text-lg-start text-center" data-aos="fade-up">
            <h1>Contact Us</h1>
            <p>
              We are dedicated to nurturing innovative minds equipped with values, knowledge, 
              and 21st-century skills, ready to thrive in a global society.
            </p>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-4 mt-4 ">
      <h3 className='color  text-center fw-bold display-5 mb-3'>Map view </h3>

    <div className="row justify-content-center">
      <div className="col-12 col-lg-12" data-aos="fade-up"> {/* Added col-lg-10 to control width */}
        <div 
          className="rounded-3 overflow-hidden shadow-sm"
          style={{
            width:"100%",
            height: '500px', // Fixed height
            margin: '0 auto' // Center the map
          }}
        >
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d36692.198056712055!2d-122.45744662978882!3d37.77022795386011!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80859a6d00690021%3A0x4a501367f076adff!2sSan%20Francisco%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1716969660518!5m2!1sen!2s"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="School Location Map"
            style={{
              border: 0,
              width: '100%',
              height: '100%' // Takes full height of parent
            }}
          />
        </div>
      </div>
    </div>
</section>

      {/* Contact Content */}
      <div className='text-center mt-2'>
      <h3 className='h2 fw-bold display-5 mb-0'>Contact <br/>
      <p className="lead text-muted max-w-800 mx-auto">For more information about our courses, get in touch</p>
          </h3>
      </div>
      <div className="contact-page py-5">
        <div className=" mx-3 px-3">
         
          <div className="row g-4">
            {/* Left Column - Contact Form */}
            <div className="col-lg-6">
              <div className="card h-100 border-dark shadow-sm">
                <div className="card-body p-4">
                  <h3 className="mb-4 pt-4 h3 fw-bold color">Send Us a Message</h3>
                  <form className=''>
                    <div className="mb-4">
                      <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Your Name" 
                        required 
                      />
                    </div>
                    <div className="mb-4">
                      <input 
                        type="email" 
                        className="form-control" 
                        placeholder="Email Address" 
                        required 
                      />
                    </div>
                    <div className="mb-4  ">
                      <textarea 
                        className="form-control" 
                        rows={5}
                        placeholder="Your Message" 
                        required
                      />
                    </div>
                    <button type="submit" className="btn  custom-hover w-100">
                      Submit Message
                    </button>
                  </form>

                  {/* Social Media Links */}
                  <div className="mt-4 pt-3  border-top">
                  <h5 className="mb-3">Connect With Us</h5>
                  <div className="d-flex flex-wrap gap-2">
                  <a 
                    href="#" 
                    className="btn btn-outline-primary rounded-circle p-0 d-flex align-items-center justify-content-center" 
                    style={{width: '40px', height: '40px'}}
                    title="Facebook"
                  >
                    <FaFacebook size={18} />
                  </a>
                  <a 
                    href="#" 
                    className="btn btn-outline-danger rounded-circle p-0 d-flex align-items-center justify-content-center" 
                    style={{width: '40px', height: '40px'}}
                    title="Instagram"
                  >
                    <FaInstagram size={18} />
                  </a>
                  <a 
                    href="#" 
                    className="btn btn-outline-danger rounded-circle p-0 d-flex align-items-center justify-content-center" 
                    style={{width: '40px', height: '40px'}}
                    title="YouTube"
                  >
                    <FaYoutube size={18} />
                  </a>
                  <a 
                    href="#" 
                    className="btn btn-outline-success rounded-circle p-0 d-flex align-items-center justify-content-center" 
                    style={{width: '40px', height: '40px'}}
                    title="WhatsApp"
                  >
                    <FaWhatsapp size={18} />
                  </a>
                </div>
                </div>
                </div>
              </div>
            </div>

            {/* Right Column - Contact Details */}
            <div className="col-lg-6">
  <div className="card h-100 border-dark shadow-sm">
    <div className="card-body p-3 p-lg-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="h3 fw-bold color mb-0">Get in Touch</h3>
        <a 
          href="https://wa.me/1234567890" 
          className="whatsapp-btn btn btn-success rounded-pill px-3 py-2 d-flex align-items-center" 
          title="Live Chat on WhatsApp"
        >
          <FaWhatsapp className="me-2" size={18} />
          <span className="d-none fw-bold d-sm-inline">Chat Now</span>
        </a>
      </div>

      <div className="contact-section">
        <div className="d-flex align-items-start mb-4 pb-4 border-bottom">
          
          <div>
            <h4 className="h6 fw-semibold mb-3 text-primary fw-bold">Head Office</h4>
            <div className="contact-item mb-3">
              <FaMapMarkerAlt className="me-2 text-info" />
              <span>123 Education Street, Knowledge City</span>
            </div>
            <div className="d-flex flex-wrap gap-4">
              <div className="contact-item">
                <FaPhone className="me-2 text-info" />
                <a href="tel:+15551234567" className="text-decoration-none color">+1 (555) 123-4567</a>
              </div> <br />
              {/* <div className="contact-item">
                <FaEnvelope className="me-2 text-info" />
                <a href="mailto:info@dnet.edu" className="text-decoration-none color">info@dnet.edu</a>
              </div> */}
            </div>
            <div className="contact-item mt-3">
                <FaEnvelope className="me-2  text-info" />
                <a href="mailto:info@dnet.edu" className="text-decoration-none color">info@dnet.edu</a>
              </div>
          </div>
        </div>

        <div className="branch-locations">
          <h4 className="h5 fw-bold mb-3 d-flex align-items-center">
            Our Campuses
          </h4>
          
          {branchLocations.map((branch, index) => (
            <div key={index} className="mb-4 pb-4 border-bottom">
              <h5 className="h6 fw-semibold mb-3 text-primary fw-bold">{branch.name}</h5>
              <div className="ps-4">
                <div className="d-flex align-items-start mb-2">
                  <FaMapMarkerAlt className="mt-1 me-2 text-muted flex-shrink-0" />
                  <span>{branch.address}</span>
                </div>
                <div className="d-flex align-items-start mb-2">
                  <FaPhone className="mt-1 me-2 text-muted flex-shrink-0" />
                  <a href={`tel:${branch.phone}`} className="text-decoration-none color" >
                    {branch.phone}
                  </a>
                </div>
                <div className="d-flex align-items-start">
                  <FaEnvelope className="mt-1 me-2 text-muted flex-shrink-0" />
                  <a href={`mailto:${branch.email}`} className="text-decoration-none color">
                    {branch.email}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quick Links */}
      <div className="border-top pt-4 mt-4 d-none">
        <h5 className="h6 fw-semibold mb-3">Quick Links</h5>
        <div className="d-flex flex-wrap gap-3">
          <a href="#" className="btn btn-outline-primary btn-sm rounded-pill px-3">
            Privacy Policy
          </a>
          <a href="#" className="btn btn-outline-primary btn-sm rounded-pill px-3">
            Terms of Use
          </a>
          <a href="#" className="btn btn-outline-primary btn-sm rounded-pill px-3">
            Careers
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;